import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Typography,
  Alert,
  DialogTitle,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchContentRef,
} from 'react-zoom-pan-pinch';

const Controls = ({ zoomIn, zoomOut, resetTransform }: ReactZoomPanPinchContentRef) => (
  <Box
    sx={{
      position: 'absolute',
      zIndex: 2,
      transform: 'translate(10px, 10px)',
      maxWidth: 'calc(100% - 20px)',
    }}
  >
    <Button onClick={() => zoomIn()}>+ Zoom in</Button>
    <Button onClick={() => zoomOut()}>- Zoom out</Button>
    <Button onClick={() => resetTransform()}>x Reset</Button>
  </Box>
);

type Props = {
  dialogState?: boolean | any;
  dialogClose?: any;
  value?: any;
  page?: number | any;
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}



export default function DocumentViewer({ dialogState, dialogClose, value, page }: Props) {
  const [docViwerActive, setDocViwerActive] = useState(false);
  const handleDocViewerChange = () => {
    setDocViwerActive(false);
    dialogClose(false);
  };
  useEffect(() => {
    setDocViwerActive(dialogState);
  }, [dialogState]);

  return (
    <Box>
      <Dialog fullScreen open={docViwerActive} onClose={handleDocViewerChange}>
        <DialogTitle>
          <Grid container direction='row' justifyContent='space-between' alignItems='center'>
            <Grid item>
              <Typography>Selected Document:</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={handleDocViewerChange}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <Paper square sx={{ minHeight: '100vh' }}>
          {value?.image !== undefined ? (
            <TransformWrapper initialScale={1} initialPositionX={50} initialPositionY={50}>
              {(utils) => (
                <React.Fragment>
                  <Controls {...utils} />
                  <TransformComponent
                    wrapperStyle={{
                      width: '100vw',
                      height: '100vh',
                      maxWidth: '100%',
                      maxHeight: 'calc(100vh - 50px)',
                    }}
                  >
                    {/* 2. Corrected typos in the checks below */}
                    {value?.image !== '' ? (
                      value?.image.includes('mp4') ||
                      value?.image.includes('pdf') ||
                      value?.image.includes('quicktime') ||
                      value?.image.includes('webm') ||
                      value?.image.includes('3gpp') ||
                      value?.image.includes('x-flv') ||
                      value?.image.includes('x-ms-asf') ||
                      value?.image.includes('mp3') ? (
                        <iframe
                          src={value?.image}
                          title='Document'
                          width='900'
                          height='700'
                        ></iframe>
                      ) : (
                        <img
                          style={{
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                          src={value?.image}
                          alt='Verification Document'
                        />
                      )
                    ) : null}
                  </TransformComponent>
                </React.Fragment>
              )}
            </TransformWrapper>
          ) : (
            <Grid container direction='row' justifyContent='center' alignItems='center' pt={8}>
              <Alert variant='outlined' severity='info'>
                Image File Not Uploaded
              </Alert>
            </Grid>
          )}
        </Paper>
      </Dialog>
    </Box>
  );
}
